import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';

@Component({
  selector: 'app-header-breadcrumb',
  templateUrl: './header-breadcrumb.component.html',
  styleUrls: ['./header-breadcrumb.component.scss']
})
export class HeaderBreadcrumbComponent implements OnInit {

  @Input() breadcrumb: Breadcrumb;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
  }

  ngOnInit() { }

  public goBack() {
    this.router.navigate([this.breadcrumb.Backlink]);
  }
  public go(route) {
    if (route.Link) {
      this.router.navigate([route.Link]);
    }
  }
}
